<template>
  <div class="flex">
    <div>
      <v-alert type="success" v-if="usercreated">
        Usuario creado exitosamente</v-alert
      >
    </div>
    <div class="justify-center">
      <v-container >
        <v-row class="flex-column">
          <v-card elevation="2" width="1000px">
            <v-col>
              <p
                class="
                  login-slogan
                  display-1
                  text-center
                  font-weight-medium
                  mb-10
                "
              >
                Crear Usuarios
              </p>
            </v-col>

            <v-form style="display: flex; align-items: center" ref="myForm">
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="name"
                  label="Nombre completo"
                  required
                  @change="addName(name)"
                ></v-text-field>
                <v-text-field
                  v-model="email"
                  label="Email"
                  required
                  @change="addEmail(email)"
                ></v-text-field>
                <v-text-field
                  v-model="createPassword"
                  :rules="passRules"
                  :type="show1 ? 'text' : 'password'"
                  label="Password"
                  hint="At least 6 characters"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  required
                  @change="addPassword(createPassword)"
                ></v-text-field>
                <v-select
                  :items="items"
                  v-model="selected"
                  :click="addRol(selected)"
                  label="Rol"
                  dense
                ></v-select>
                <!-- <v-select
                  :items="empresas"
                  v-model="selectedEmpresa"
                  :click="addEmpresa(selectedEmpresa)"
                  label="Empresa"
                  dense
                ></v-select> -->
                <v-checkbox
                  v-for="(element, index) in empresas"
                  :key="index"
                  v-model="selectedEmpresa"
                  :label="element"
                  :value="element"
                  :click="addEmpresa(selectedEmpresa)"
                ></v-checkbox>
                <v-btn
                  large
                  block
                  :disabled="
                    name.length === 0 ||
                    email.length === 0 ||
                    createPassword === 0
                  "
                  color="primary"
                  @click="createUser"
                >
                  Crear Usuario</v-btn
                >
              </v-col>

              <v-col cols="2"></v-col>
            </v-form>
          </v-card>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
// import EquipoStore from "../store/index";
import { mapState } from "vuex";
import { addUser, register, getAlluser } from "../database.js";

export default {
  name: "RegisterView",

  components: {},
  data() {
    return {
      selected: null,
      selectedEmpresa: [],
      usercreated: false,
      name: "",
      email: "",
      show1: false,
      createPassword: "Mendoza2023",
      password: "Mendoza2023",
      items: [
        "Administrador",
        "Técnico",      
      ],
      empresas: ["Westnet", "Optix", "Bigway"],
      passRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 6 || "Min 6 characters",
      ],
      newuser: {
        id: "",
        nombre: "",
        email: "",
        password: "",
        rol: "",
        empresa: [],
        instalaciones: [],
        servicio_tecnico: [],
        cambio_tecnologia: [],
        libres: "",
        en_uso: "",
        importetotal: 0,
      },
      newtecnico: {
        nombre: "",
        empresa: "",
        idusuario: "",
      },
    };
  },
  computed: {
    ...mapState({
      newuserdata: (state) => state.newuser,
      idnewuser: (state) => state.idnewuser,
      idtecnico: (state) => state.idtecnico,
    }),
  },
  methods: {
    addName(data) {
      this.newuser.nombre = data;
      console.log("nomrbre", data);
      this.usercreated = false
      // let propiedad = "nombre";
      // EquipoStore.methods.addnewUser(propiedad, data);
      // console.log("store: ", EquipoStore.data.usuarios[0].nombre);
    },
    addEmail(data) {
      this.newuser.email = data;
      // console.log(data);
      // let propiedad = "email";
      // EquipoStore.methods.addnewUser(propiedad, data);
      // console.log("store: ", EquipoStore.data.usuarios[0].email);
    },
    addPassword(data) {
      this.newuser.password = data;
      // console.log(data);
      // let propiedad = "password";
      // EquipoStore.methods.addnewUser(propiedad, data);
      // console.log("store: ", EquipoStore.data.usuarios[0].password);
    },
    addRol(data) {
      this.newuser.rol = data;
      // console.log(data);
      // let propiedad = "rol";
      // EquipoStore.methods.addnewUser(propiedad, data);
      // console.log("store: ", EquipoStore.data.usuarios[0].rol);
      // console.log("store object: ", EquipoStore.data.usuarios);
    },
    addEmpresa(data) {
      this.newuser.empresa = data;
      // console.log(data);
      // let propiedad = "empresa";
      // EquipoStore.methods.addnewUser(propiedad, data);
      // console.log("store: ", EquipoStore.data.usuarios[0].empresa);
      // console.log("store object: ", EquipoStore.data.usuarios);
    },
    // generateId() {
    //   const fecha = new Date();
    //   const timestamp = fecha.getTime();
    //   this.id = timestamp;
    //   console.log(this.id);
    //   // let propiedad = "id";
    //   // EquipoStore.methods.addnewUser(propiedad, this.id);
    //   // console.log("id store:", EquipoStore.data.usuarios[0].id);
    // },
    async createUser() {
      // this.generateId();
      console.log("createUSUARIO", this.newuser);
      // const data = JSON.stringify(...EquipoStore.data.usuarios);
      // console.log(data);
      //creo un usuario
      this.$store.dispatch("setNewUser", this.newuser);
      await addUser();
      // creo un usuario para autenticar
      await register(this.email, this.password);
      await getAlluser();
      // if(this.newuserdata[0].rol !== "Administrator"){
      //   //creo un tecnico
      //   this.newtecnico.nombre = this.newuser.nombre
      //   this.newtecnico.empresa = this.newuser.empresa
      //   this.newtecnico.idusuario = this.idnewuser
      //   console.log("new tecnico",this.newtecnico)
      //   this.$store.dispatch('setTecnico',this.newtecnico);
      //   await addTecnico()
      //   //actualiza el usuario con el idtecnico
      //   console.log(this.idtecnico)
      //   let idTecnico = {
      //     idtecnico : this.idtecnico,
      //   }
      //   this.$store.commit('SET_IDTECNICO',idTecnico)
      //   // this.$store.dispatch('setIdTecnico',idTecnico);
      //   await updateIdUser(this.idnewuser)
      // }
      this.usercreated = true;
      this.name = "";
      this.email = "";
      this.items = [
        "Administrador",
        "Técnico"       
      ];
      this.selectedEmpresa = [];
    },
  },
};
</script>